import {
  isSchemaConditionValue,
  type SchemaField,
  type SchemaFieldSelectValue,
  type SchemaFieldSelectValueLegacy,
} from "@/entities/schema";
import { isValidObject } from "@/utilities/object";

export const schemaHasVisibleCondition = (schema: SchemaField): boolean => {
  if (isSchemaConditionValue(schema.visible)) return true; // Handle legacy format

  return schema.visible?.length ? true : false;
};

export const schemaHasValuesCondition = (schema: SchemaField): boolean => {
  if (schema.type !== "select") return false;

  const { values } = schema;

  if (!values?.length) return false;

  const hasConditions = values.map(selectFieldValueHasCondition);

  return hasConditions.includes(true);
};

export const selectFieldValueHasCondition = (
  value: SchemaFieldSelectValue | SchemaFieldSelectValueLegacy
): boolean => {
  if (!isValidObject(value)) return false;

  return (value.conditions ?? []).length > 0;
};

export const getSchemaFieldFlags = (schema: SchemaField) => {
  return {
    hasVisibleCondition: schemaHasVisibleCondition(schema),
    hasValuesCondition: schemaHasValuesCondition(schema),
  };
};
